export const SmtpAccountStatus = {
  INACTIVE: 0,
  ACTIVE: 1
};

export const SmtpAccountConnectionState = {
  DISCONNECTED: 0,
  CONNECTED: 1
};

export const SMTP_TYPES = {
  GMAIL: 'gmail',
  OUTLOOK: 'outlook',
  SENDGRID: 'sendgrid'
};
